import React from 'react';
import { observer } from 'mobx-react';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

import classes from './HeaderSolutionSwitcher.module.scss';
import { solutionsStore } from '../../../stores/solutionsStore';
import { SOLUTION_TYPE } from '../../../constants/user-info/solutionType';
import { LbMenu } from '../../../components/menu-components';
import { MenuOptions } from '../../../../general-types';
import { OptionWithDescription } from '../../../components/form-components';
import { HeaderLogo } from '../../../components/header-components/HeaderLogo/HeaderLogo';

const HeaderSolutionSwitcher = observer(() => {
  const { activeSolution, solutionTypeFlags, handleSolutionChange } = solutionsStore;

  const menuOptions: MenuOptions[] = [
    {
      id: SOLUTION_TYPE.NUTRITION,
      label: (
        <OptionWithDescription
          label="LifeBase Solutions"
          description="Support healthy nutrition"
        />
      ),
      onClick: () => handleSolutionChange(SOLUTION_TYPE.NUTRITION),
      isHide: !solutionTypeFlags.NUTRITION,
    },
    {
      id: SOLUTION_TYPE.SCAN_IQ,
      label: (
        <OptionWithDescription label="ScanIQ" description="Monitor InBody indicators" />
      ),
      onClick: () => handleSolutionChange(SOLUTION_TYPE.SCAN_IQ),
      isHide: !solutionTypeFlags.SCAN_IQ,
    },
    {
      id: SOLUTION_TYPE.CHALLENGE,
      label: (
        <OptionWithDescription
          label="Challenges"
          description="Manage wellness challenges"
        />
      ),
      onClick: () => handleSolutionChange(SOLUTION_TYPE.CHALLENGE),
      isHide: !solutionTypeFlags.CHALLENGE,
    },
  ];

  return (
    <LbMenu
      buttonProps={{
        variant: 'unstyled',
        className: classes.triggerButton,
        endIcon: <KeyboardArrowDownRoundedIcon />,
        disableRipple: true,
      }}
      options={menuOptions}
    >
      <HeaderLogo solution={activeSolution} />
    </LbMenu>
  );
});

export { HeaderSolutionSwitcher };
